import React, { useState } from "react";
import DashboardFooter from "../../Common/DashboardFooter";

import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import SidePanelAdmin from "../../Common/SidePanelAdmin";
import TitleBar from "../../Common/TitleBar";
import DashboardHeader from "../../Common/DashboardHeader";
import { ScrollPanel } from "primereact/scrollpanel";

import { useDispatch } from "react-redux";
import { FaSpinner } from "react-icons/fa";
import { fetchAdminLeaderDashboardAction } from "../../../Redux/Actions/AdminLeaderDashboard";

const LeaderMain = () => {
  const [isActive, setIsActive] = useState(true);
  const [activityData, setActivityData] = useState([]);

  const [loader, setLoader] = useState({
    fetch: false,
    export: false,
  });
  const dispatch = useDispatch();
  const toggleClass = () => {
    setIsActive(!isActive);
  };
  const [date, setDate] = useState(null);
  const [typeId, setTypeId] = useState(null);

  const optionType = [
    { name: "Daily", code: "1" },
    { name: "Weakly", code: "2" },
    { name: "Monthly", code: "3" },
    { name: "Yearly", code: "4" },
  ];
  const handleSubmit = () => {
    let formData = {
      type: typeId?.code,
      date: date.toISOString().split("T")[0],
    };
    setLoader({
      ...loader,
      fetch: true,
    });
    dispatch(
      fetchAdminLeaderDashboardAction(
        "leaderboard-result",
        formData,
        setActivityData,
        setLoader,
        loader
      )
    );
  };

  return (
    <>
      <TitleBar title="Leader-Dashboard" />
      <div className="dashboard earnings_payouts container-fluid overflow-hidden">
        <div className="row">
          <div
            className={`col-lg-2 col-md-3 col-sm-4 col-12 side-nav ${
              isActive ? "nav-show" : "nav-hide"
            }`}
          >
            <SidePanelAdmin />
          </div>
          <div
            className={` p-0 ${
              isActive ? "col-lg-10 col-md-9 col-sm-8 col-12" : "col-12"
            } main-content`}
          >
            <div>
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 ps-0 pe-0">
                  <div className="dashboard-in main_task_wrapper">
                    <DashboardHeader
                      toggleSidebar={toggleClass}
                      title="Activity"
                    />
                    <ScrollPanel
                      className="custombar2 content-area pt-0"
                      style={{ height: "100vh" }}
                    >
                      <div className="content-area-in tab-style">
                        <div className="creator_new_task h-100">
                          <div className="account-block">
                            <div className="row">
                              <div className="col-lg-3">
                                <div className="submission_wrap submission_bg mb-4">
                                  <lab for="" className="form-label mb-3">
                                    Type
                                  </lab>
                                  <Dropdown
                                    value={typeId}
                                    onChange={(e) => setTypeId(e.value)}
                                    options={optionType}
                                    optionLabel="name"
                                    placeholder="Select task type"
                                    className="w-full broder-0 "
                                  />
                                </div>
                              </div>

                              <div className="col-lg-3">
                                <div className="submission_wrap submission_bg gap-1 placeholder-demo mb-4">
                                  <lab for="" className="form-label mb-0">
                                    Select Date
                                  </lab>
                                  <Calendar
                                    placeholder="Date"
                                    value={date}
                                    onChange={(e) => setDate(e.value)}
                                  />
                                </div>
                              </div>

                              <div className="d-flex justify-content-end gap-2">
                                <button
                                  className="theme-btn px-4"
                                  type="button"
                                  onClick={handleSubmit}
                                  disabled={!(date && typeId)}
                                  style={{
                                    background: !(date && typeId) ? "grey" : "",
                                    cursor: !(date && typeId)
                                      ? "not-allowed"
                                      : "pointer",
                                  }}
                                >
                                  {loader.fetch ? (
                                    <>
                                      Searching{" "}
                                      <FaSpinner className="spin ms-1" />
                                    </>
                                  ) : (
                                    "Search"
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="table-responsive position-relative earnings_table mt-1">
                            <table className="table theme-table">
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>userId</th>
                                  <th>Rank</th>
                                  <th>Name</th>

                                  <th>Email</th>
                                  <th>Mobile No.</th>
                                  <th>Points</th>
                                </tr>
                              </thead>

                              <div
                                className="d-flex align-items-center justify-content-center"
                                style={{ width: "100%", position: "absolute" }}
                              ></div>
                              <tbody>
                                {activityData.length > 0 ? (
                                  activityData.map((curElem, i) => {
                                    return (
                                      <tr key={i}>
                                        <td data-label="S.No">{i + 1}</td>
                                        <td data-label="userId">
                                          {curElem.userId}
                                        </td>
                                        <td data-label="Rank">
                                          {curElem.user_rank}
                                        </td>
                                        <td data-label="User">
                                          <span className="userImg">
                                            <img
                                              src={
                                                curElem.profile
                                                  ? curElem.profile
                                                  : "https://images.pexels.com/photos/2169434/pexels-photo-2169434.jpeg"
                                              }
                                              alt=""
                                            />
                                          </span>
                                          {curElem.name}
                                        </td>

                                        <td data-label="Email">
                                          {curElem.email}
                                        </td>
                                        <td data-label="Mobile No.">
                                          {curElem.mobileNumber}
                                        </td>
                                        <td data-label="Points">
                                          {curElem.totalpoints}
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <td className="text-center pt-3" colSpan={7}>
                                    No user data found
                                  </td>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </ScrollPanel>
                    <div className="d-none d-lg-block">
                      <DashboardFooter />
                    </div>
                  </div>
                </div>
                <div className="d-block d-lg-none">
                  <DashboardFooter />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaderMain;
